import React from 'react';
import { Box, Typography } from '@mui/material';
import { TEducation } from '../../../types/User';
import { typeMappingHandler } from '../../../constants/keysMapping';
import './ed.scss';

interface EducationalCardProps {
  education: TEducation;
}

const EducationalCard: React.FC<EducationalCardProps> = (props) => {
  const { education } = props;
  const { degreeLevel, major, university, endYear, fromYear, iAmStillStudying } = education || {};

  return (
    <Box className='mainCard'>
      <Box className='mainContent'>
        <Box className='content'>
          <Typography className='title'>
            {typeMappingHandler(degreeLevel).message}
            {':'}
            {major}
          </Typography>

          <Typography color='text.light' fontSize='small'>
            {university}
          </Typography>

          <Typography color='text.light' fontSize='small'>
            {fromYear}
            {' - '}
            {iAmStillStudying ? 'تاکنون' : endYear}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default EducationalCard;
